<template>
	<div class="contianer">
		<!-- 头部标题 -->
			<van-nav-bar left-text="返回" :title="classes" left-arrow @click-left="onClickLeft"/>
		<!-- 顶部导航 -->
		<div class="top-nav">
			<van-tabs v-model="activeNav" line-width=20 title-active-color=" #FF795C" title-inactive-color="#000" sticky >
				<van-tab title="章节练习" class="textWitdh">
					<!-- 章节分类列表 -->
					<div class="exam-box" @click="getSectionsList()" >
						<!-- 章 -->
						<div class="chaptersList" >
							<div class="chaptersList-box" :class="{activeChapter:activeChapter==0}">
								<div class="chaptersList-title">第一章</div>
								<div class="chaptersList-text">导论</div>
							</div>
							<div class="chaptersList-box">
								<div class="chaptersList-title">第一章</div>
								<div class="chaptersList-text">导论</div>
							</div>
						</div>
						<!-- 节 -->
						<div class="sectionsList">
							<div class="sectionsList-title">第一节： 公务员概述</div>
							<div class="sectionsList-text">
								<div>一、公务员的含义</div>
								<div><span>20</span>/50</div>
							</div>
							<div class="sectionsList-text">
								<div>二、公务员的含义</div>
								<div><span>20</span>/50</div>
							</div>
							<div class="sectionsList-text">
								<div>三、公务员的含义</div>
								<div><span>20</span>/50</div>
							</div>
						</div>
					</div>
					<!-- <div class="exam-box">
						<div class="chaptersList">
							<div class="chaptersList-title">第一章</div>
							<div class="chaptersList-text">导论</div>
						</div>
						<div class="sectionsList"></div>
					</div> -->
				</van-tab>
				<van-tab title="知识点">内容 2</van-tab>	
			</van-tabs>
		</div>
		
	</div>
</template>

<script>
	export default{
		data() {
			return {
				classes: '未选择',//课程名称
				activeNav:0,//当前选中导航
				activeChapter:0,//当前选中章
			}
		},
		methods: {
			//获取节列表
			getSectionsList() {
				
			},
			//返回上一页
			onClickLeft(){
				this.$router.go(-1)
			}
		},
	}
</script>

<style>
	.contianer{
		width: 100%;
		min-height: 100vh;
		background: #fff;

	}
	/* 顶部导航 */
	.top-nav{
		font-weight: bold;
	}
	/* 章节分类列表 */
	.exam-box{
		display: flex;
		width: 100%;
		min-height: 100vh;
	}
	/* 章 */
	.chaptersList{
		width: 30%;
		background: #F5F4F9;
	}
	.chaptersList-box{
		width: 100%;
		height: 4rem;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		border-bottom: 1px solid #EBEDEF;
	}
	.chaptersList-title{
		margin-left: 1.25rem;
		color: #333;
	}
	.chaptersList-text{
		margin-left: 1.25rem;
		color:#999 ;
		font-weight: normal;
	}
	.activeChapter{
		background: #fff;
	}
	/* 节 */
	.sectionsList{
		width: 60%;
		padding: 0 5%;
	}
	.sectionsList-title{
		width: 100%;
		height: 2rem;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EBEDEF;
		color: #333;
	}
	.sectionsList-text{
		width: 100%;
		height: 3rem;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EBEDEF;
		font-weight: normal;
		color: #999;
		display: flex;
		justify-content: space-between;
	}
	.sectionsList-text span{
		color: #FF795C;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/ExamList.vue